import { TextTruncateComponent } from './text-truncate/text-truncate.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AppointmentRequestDescriptionPipe } from '../home/appointment-requests/appointment-request-description.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateByObjectPipe } from './pipes/translate-by-object.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { BytesSizePipe } from './pipes/bytes-size.pipe';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { DateTimeFormatPipe } from './pipes/date-time-format.pipe';
import { TimezoneFormatPipe } from './pipes/timezone-format.pipe';
import { DisplayNamePipe } from './pipes/display-name.pipe';
import { DisplayTerritoryPipe } from './pipes/display-territory.pipe';
import { PhonePipe } from './pipes/phone.pipe';

import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AttachmentComponent } from './attachment/attachment.component';
import { DatePickerComponent } from './datepicker/datepicker.component';
import { AttachmentDisplayComponent } from './attachment-display/attachment-display.component';
import { AppointmentMomentPreferencesComponent } from './appointment-moment-preferences/appointment-moment-preferences.component';
import { PetalLogoComponent } from './petal-logo/petal-logo.component';
import { PetalLogoDarkComponent } from './petal-logo/petal-logo-dark.component';
import { PetalLogoLightComponent } from './petal-logo/petal-logo-light.component';
import { PetalLogoWhiteComponent } from './petal-logo/petal-logo-white.component';

import { AppointmentCardComponent } from './appointment-card/appointment-card.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ContactMethodsComponent } from './contact-methods/contact-methods.component';
import { ContactMethodComponent } from './contact-method/contact-method.component';

import { NavigationExternalComponent } from './navigation-external/navigation-external.component';

import { FeedbackMessageComponent } from './feedback-message/feedback-message.component';
import { LayoutBoxComponent } from './layout-box/layout-box.component';

import { AppointmentsService } from './services/appointments.service';
import { NgReduxStub } from './services/ng-redux-stub.service';
import { ReasonsService } from './services/reasons.service';
import { SecurityService } from './services/security.service';

import { FlashComponent } from './flash/flash.component';
import { FlashUpdateEmailComponent } from './flash/flash-update-email/flash-update-email.component';
import { FlashUpdateProfileComponent } from './flash/flash-update-profile/flash-update-profile.component';
import { FlashErrorComponent } from './flash/flash-error/flash-error.component';
import { FlashInfoComponent } from './flash/flash-info/flash-info.component';
import { FlashUpdateComponent } from './flash/flash-update/flash-update.component';

import { PatientNameComponent } from './patient-name/patient-name.component';

import { HinFormatDirective } from './directives/hin-format.directive';
import { UISrefDirective } from './directives/ui-sref.directive';

import { AppHeaderComponent } from './app-header/app-header.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppInputComponent } from './app-input/app-input.component';
import { AppButtonComponent } from './app-button/app-button.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { ContactMethodsSelectorComponent } from './contact-methods-selector/contact-methods-selector.component';
import { LinkifyPipe } from './pipes/linkify.pipe';

const providers: any[] = [
  { 
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticationInterceptor, 
    multi: true,
  },
  NgReduxStub,
  SecurityService,
  AppointmentsService,
  ReasonsService,
  DisplayNamePipe,
  LinkifyPipe,
];

@NgModule({
  declarations: [
    AttachmentComponent,
    DatePickerComponent,
    AttachmentDisplayComponent,
    AppointmentRequestDescriptionPipe,
    BytesSizePipe,
    CapitalizeFirstPipe,
    DateTimeFormatPipe,
    DisplayNamePipe,
    LinkifyPipe,
    DisplayTerritoryPipe,
    FlashComponent,
    FlashErrorComponent,
    FlashInfoComponent,
    FlashUpdateComponent,
    FlashUpdateEmailComponent,
    FlashUpdateProfileComponent,
    TimezoneFormatPipe,
    OrderByPipe,
    TranslatePipe,
    TranslateByObjectPipe,
    TruncatePipe,
    PhonePipe,
    TextTruncateComponent,
    AppointmentMomentPreferencesComponent,
    PetalLogoComponent,
    PetalLogoDarkComponent,
    PetalLogoLightComponent,
    PetalLogoWhiteComponent,
    LayoutBoxComponent,
    AppHeaderComponent,
    AppFooterComponent,
    NavigationExternalComponent,
    AppInputComponent,
    AppButtonComponent,
    ChecklistComponent,
    ChecklistItemComponent,
    FeedbackMessageComponent,
    AppointmentCardComponent,
    SpinnerComponent,
    ContactMethodsComponent,
    ContactMethodComponent,
    PatientNameComponent,
    ContactMethodsSelectorComponent,
    HinFormatDirective,
    UISrefDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers,
  exports: [
    AttachmentComponent,
    DatePickerComponent,
    AttachmentDisplayComponent,
    AppointmentRequestDescriptionPipe,
    BytesSizePipe,
    CapitalizeFirstPipe,
    DateTimeFormatPipe,
    DisplayNamePipe,
    LinkifyPipe,
    DisplayTerritoryPipe,
    TimezoneFormatPipe,
    OrderByPipe,
    TranslatePipe,
    TranslateByObjectPipe,
    TruncatePipe,
    PhonePipe,
    TextTruncateComponent,
    AppointmentMomentPreferencesComponent,
    PetalLogoComponent,
    PetalLogoDarkComponent,
    PetalLogoLightComponent,
    PetalLogoWhiteComponent,
    LayoutBoxComponent,
    AppHeaderComponent,
    AppFooterComponent,
    NavigationExternalComponent,
    AppInputComponent,
    AppButtonComponent,
    ChecklistComponent,
    ChecklistItemComponent,
    FeedbackMessageComponent,
    AppointmentCardComponent,
    SpinnerComponent,
    ContactMethodsComponent,
    ContactMethodComponent,
    PatientNameComponent,
    ContactMethodsSelectorComponent,
    HinFormatDirective,
    UISrefDirective,
  ],
  entryComponents: [
    DatePickerComponent,
    LayoutBoxComponent,
    AppointmentMomentPreferencesComponent,
    AppInputComponent,
    AppButtonComponent,
    FeedbackMessageComponent,
    FlashComponent,
    AppHeaderComponent,
    AppFooterComponent,
    PatientNameComponent,
  ],
})

export class SharedModule {}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/shared.module.ts